import { mapState } from 'vuex';
import filter from 'lodash.filter';

export default {
    name: 'TrophyMixin',

    computed: {

        ...mapState([
            'trophies'
        ]),

        achievedTrophies() {
            return filter(this.trophies, function (trophy) {
                return trophy.category === 'custom' || trophy.progress >= 100
            });
        },
    },
}